import { createMutation } from "/npm/@tanstack/solid-query@^5.67.1/+esm";

import client from "/npm/@brytdesigns/shopify-hybrid-cart@0.1.29/dist/jsdelivr/client.js";
import API from "/npm/@brytdesigns/shopify-hybrid-cart@0.1.29/dist/jsdelivr/api.js";
import { Cart } from "/npm/@brytdesigns/shopify-hybrid-cart@0.1.29/dist/jsdelivr/query/index.js";

export type Input = Parameters<typeof API.add>[0]["items"][number];

export const mutation = createMutation(
  () => ({
    mutationFn: async (items: Input[]) => {
      const response = await API.add({ items });
      if (response?.error || !response.data) {
        throw response?.error;
      }
      return response.data;
    },
    onSettled() {
      Cart.invalidate();
    },
  }),
  () => client,
);
